import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SkillSuggestion {
  indicatorId: string;
  indicatorName: string;
  relevanceScore: number;
  reason: string;
}

export interface SuggestSkillsRequest {
  title: string;
  description?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AiService {
  private readonly baseUrl = `${environment.apiUrl}/ai`;

  constructor(private http: HttpClient) {}

  suggestSkills(request: SuggestSkillsRequest): Observable<SkillSuggestion[]> {
    return this.http.post<SkillSuggestion[]>(`${this.baseUrl}/suggest-skills`, request);
  }
}

